import { render, staticRenderFns } from "./orderManagementDetail.vue?vue&type=template&id=44e0075f&scoped=true"
import script from "./orderManagementDetail.vue?vue&type=script&lang=js"
export * from "./orderManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./orderManagementDetail.vue?vue&type=style&index=0&id=44e0075f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e0075f",
  null
  
)

export default component.exports